import { FC } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { appLoaderTranslations } from './translations';
import { IAppLoaderProps } from './types';
import { AppLoaderTransFields } from './types';
import styles from './appLoader.module.scss';

export const AppLoader: FC<IAppLoaderProps> = ({ wrapped = false }) => {
  const { t } = useMyTranslations<AppLoaderTransFields>([appLoaderTranslations.name]);

  return wrapped ? (
    <div className={styles.main}>
      <p>{t('loading')}</p>
    </div>
  ) : (
    <p>{t('loading')}</p>
  );
};
